module.exports = __webpack_public_path__ + "media/take-my-hand.27ed918d.mp3";